import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';

import { Filter, Main } from 'Containers';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { submitDelay } from 'Common/GeneralHelper';
import { APPLICATION_MEMBER_FORM_NAME } from 'Common/FormEnum';
import { addToQueryString } from 'Common/Helpers/querystring';

import { updateMember } from '../state/hub/actions';
import { EMPTY_INCOME, MODIFY_BUTTON_TEXT } from '../helpers/Constants';
import MemberForm from '../components/member/MemberForm';

class MemberContainer extends Component {
  static path = '/manageapplication/:familyId/member/:memberId';

  getRootUrl = () => {
    const { isSecondReview, history } = this.props;
    const currentQueryString = _.get(history, 'location.search', '');

    if (isSecondReview) {
      const queryString = addToQueryString(currentQueryString, {
        secondReview: 1,
      });
      let url = this.props.match.url.replace(/\/member\/.*/gi, '');
      url = `${url}${queryString}`;
      return url;
    }
    return `${this.props.match.url.replace(
      /\/member\/.*/gi,
      ''
    )}${currentQueryString}`;
  };

  componentDidMount() {
    //if no members kick back
    if (!this.props.members) {
      this.props.history.replace(this.getRootUrl());
    }
  }

  getMember = () => {
    const { memberId } = this.props.match.params;

    if (this.props.members) {
      let member = this.props.members.find(
        (x) => !x.IsHOH && x.Id === memberId
      );
      if (member !== undefined) {
        return member;
      } else {
        const newMem = {
          Id: `${memberId}`,
          FirstName: '',
          LastName: '',
          SSN: '',
          IsHOH: false,
          Income: { ...EMPTY_INCOME },
        };
        return newMem;
      }
    }
  };

  saveMember = (values) => {
    return submitDelay().then(() => {
      this.props.updateMember(values);
      this.props.history.push(this.getRootUrl());
    });
  };

  getMainProps = () => {
    const { isReadOnly } = this.props;

    return {
      usePageWidth: true,
      toolbox: {
        isReadOnly,
        backButtonProps: { shown: true, path: this.getRootUrl() },
        formName: APPLICATION_MEMBER_FORM_NAME,
        saveButtonProps: {
          content: MODIFY_BUTTON_TEXT,
        },
        shown: true,
      },
    };
  };

  render() {
    return (
      <Fragment>
        <Filter title={'Household Member'} />
        <Main {...this.getMainProps()}>
          <MemberForm
            initialValues={this.getMember()}
            onSubmit={this.saveMember}
            familyId={this.props.match.params.familyId}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { hub } = state.ManageApplicationState;

  ownProps.setPageLevelDirty(getIsDirty(APPLICATION_MEMBER_FORM_NAME)(state));

  return {
    members: hub.tempApplication.Members,
    isSecondReview: hub.isSecondReview,
  };
};

export const Member = withRouter(
  connect(mapStateToProps, { updateMember })(MemberContainer)
);



// WEBPACK FOOTER //
// ./src/pages/manageapplication/subpages/Member.js